import _ from 'lodash'
import { deserialize } from 'cerialize'
import { getDate, getTime } from 'Helpers'
import { ProductModel } from 'Pages/orders'

export class BlockProductGroupModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public slug: string
	@deserialize public created_at?: string
	@deserialize public updated_at?: string
	@deserialize public products: ProductModel[]
	@deserialize public product_ids: number[]

	public constructor(obj) {
		if (!obj) return
		if (obj.id) this.id = obj.id
		if (obj.name) this.name = obj.name
		if (obj.slug) this.slug = obj.slug
		if (obj.products) this.products = obj.products
		if (obj.product_ids) this.product_ids = obj.product_ids
	}

	public get created_date(): string {
		return `${getDate(this.created_at)} ${getTime(this.created_at)}`
	}
	public get updated_date(): string {
		return `${getDate(this.updated_at)} ${getTime(this.updated_at)}`
	}
	public get get_product_ids(): string {
		return _.map(this.products || [], (product): number => product.id).join(',')
	}
	public get get_product_name(): string {
		return _.map(this.products || [], (product): string => product.name).join(', ')
	}
}
